import { render, staticRenderFns } from "./versionManagement.vue?vue&type=template&id=4bd47eb6&scoped=true&"
import script from "./versionManagement.vue?vue&type=script&lang=js&"
export * from "./versionManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd47eb6",
  null
  
)

export default component.exports